import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        token: '',
        appId: '',
        userInfo:undefined,
        balance:0,//可提现金额
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
        setAppId(state,appId){
            state.appId = appId;
        },
        setUserInfo(state,userInfo){
            state.userInfo = userInfo
        },
        clear(state){
            state.token = '',
            state.appId = '',
            state.userInfo = undefined
        },
        setBalance(state,balance){
            state.balance = balance
        }
    
    },
    actions: {

    }
});
